import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { State } from 'src/app/shared/state/state';
import { User } from 'src/app/shared/dtos/user.dto';
import { InombraRoutes } from 'src/app/models/routes';
import { Router, RouterModule } from '@angular/router';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { CommonModule } from '@angular/common';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { UsernamePipe } from '../../pipes/username.pipe';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzAvatarModule,
    NzPopoverModule,
    UsernamePipe,
    NzIconModule,
  ],
})
export class AvatarComponent implements OnChanges {
  readonly state = inject(State);
  readonly router = inject(Router);
  readonly InombraRoutes = InombraRoutes;
  @Input() user_id;
  @Input() textOnly = false;
  @Input() size: 'small' | 'large' | number = 32;
  @Input() multiple = false;
  @Input() users = [];
  @Input() tooltip = true;
  @Input() discreet = false;
  @Input() popoverPlacement = 'top';

  visitProfile(id: number): void {
    this.router.navigateByUrl(`/${InombraRoutes.Profile}?id=${id}`);
  }

  user = {} as User;
  ngOnChanges(): void {
    if (this.user_id) {
      this.user = this.state.users.find(i => i.id == this.user_id);
    }
  }
}
